import React, { Component } from 'react'
import AppContainer from './App-style'
import Konkurrence from './feature/konkurrence'
import Postnummer from './feature/postnummer'
import 'babel-polyfill'
import { getParameterByName } from './component/functions'


class App extends Component {
    componentWillMount() {
        let showComponent = 'Konkurrence'
        if (getParameterByName('showcomponent') === 'Postnummer') showComponent = 'Postnummer'
        this.setState({
            showComponent
        })
    }
    componentDidMount() {
        console.log('did mount')
    }
    render() {
        return (
            <AppContainer>
                {(this.state.showComponent==='Konkurrence') && <Konkurrence />}
                {(this.state.showComponent==='Postnummer') && <Postnummer />}
            </AppContainer>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js